import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";

/**
 * The clock and battery are drawn by iOS, over our background, and iOS will not work out
 * which colour they should be. Unset, a dark app gets black text on black.
 *
 * `Style.Dark` means "dark content"… no: in this plugin `Style.Dark` means the bar renders
 * for a DARK background, i.e. light text. The naming has bitten enough people that it is
 * written out here rather than left to a reader's memory.
 */
const supported = Capacitor.isNativePlatform();

export const statusBar = {
  /** Light text — use on a dark background. */
  useLightContent() {
    if (supported) void StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
  },
  /** Dark text — use on a light background. */
  useDarkContent() {
    if (supported) void StatusBar.setStyle({ style: Style.Light }).catch(() => {});
  },
  /** Follow the OS appearance. The app's own theme should usually decide instead. */
  followSystem() {
    if (supported) void StatusBar.setStyle({ style: Style.Default }).catch(() => {});
  },
  /**
   * Binds the bar to the app's own appearance.
   *
   * The design system has no decided dark palette, so the app renders light whatever the
   * phone is set to — and the status bar has to agree, or a phone in dark mode shows white
   * clock text on the app's white background. Following the OS here would be following
   * something the app deliberately does not follow.
   */
  bindToColorScheme(): () => void {
    if (!supported) return () => {};
    statusBar.useDarkContent();
    return () => {};
  },
};
